import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const AccessDenied = () => {
    useEffect(() => {
        document.title = "Access Denied";
    }, []);

    const navigate = useNavigate();

    return (
        <main className="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
            <div className="text-center">
                <p className="text-base font-semibold text-red-600">403 - Access Denied</p>
                <h1 className="mt-10 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">Access Restricted</h1>
                <p className="mt-6 text-base leading-7 text-gray-600">Sorry, you don’t have permission to view this page.</p>
                <div className="mt-10 flex items-center justify-center gap-x-6">
                    <button
                        onClick={() => navigate('/gp/dashboard')}
                        className="rounded-md bg-zinc-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-zinc-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-zinc-600"
                    >
                        Go to Dashboard
                    </button>
                </div>
            </div>
        </main>
    );
}

export default AccessDenied;
